/*                              @Author : {}
* Copyright (c) 2021, by Tush Entertainment
* Permission to use, copy, modify or distribute this software in binary or source form
* for any purpose is allowed only under explicit prior consent in writing from Tush Entertainment.
* THE SOFTWARE IS PROVIDED "AS IS" AND TUSH ENTERTAINMENT DISCLAIMS
* ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
* WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL TUSH ENTERTAINMENT
* BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
* DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
* PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
* ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
* SOFTWARE.THIS SOFTWARE IS PROTECTED BY COPYRIGHT LAWS FROM INDIA AND USA.
* ANY OR ALL PART OF THIS SOFTWARE OR SOURCES CANNOT BE USED FOR ANY TYPES OF
* PRODUCTS WHICH IS DIRECTLY AND INDIRECTLY AFFECTING THE LIFE OF HUMANS.
*/
import React, {useEffect, useState} from 'react';
import '../css/App.css';
import '../css/Home.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/content.css';
import Select from 'react-select';
import sampler from '../Objects/axiosjson';
import alertinstance from '../Objects/Alert';
import { useNavigate,Link } from 'react-router-dom';
import Spin from './Spinner/Spin';
import AsyncSelect from 'react-select/async';
import {Listapp_type,Listpackage_type, prices_type} from '../Objects/Country';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useParams } from 'react-router-dom';
const Addsubscomponent = ({icon}) => {
    let navigate = useNavigate()
    let {packageId}=useParams()
    let {packageName}=useParams()
    const [name,setname]=useState('');
    const [platforms,setplatforms]=useState({label:"Android Phone"});
    const [ca,setca]=useState('');
    const [ct,setct]=useState('');
    const [period,setperiod]=useState('');
    const [price,setprice]=useState([]);
    const [couponf,setcouponf]=useState(false)
    const [loading,setloading]=useState(false)
    const [appType,setappType]=useState([])
    const [isrecurring,setisrecurring]=useState(false)
    const [packageType,setpackageType]=useState({label:'onetime',value:'onetime'})
    //---------------------------------for managing benefits -------------------------------------//
    const [status,setstatus]=useState([])
    const [searches, setSearches] = useState([])
    const [query, setQuery] = useState("")
    const [labelText,setLabelText]=useState("Add Package");
    //options for select country code
    useEffect(()=>{
        const beni=()=>{
            const data = {
                platform :''
            }
            sampler.post('/listPackages',data)
            .then(res=>{
                call(res.data.data)
            })
        }

       if(packageId && packageName){
        beni()
        setLabelText("Update Package")
       }else{
        setLabelText("Add Package")
       }
    },[])

    const call =(val)=>{
        let rapptype = []
        for (var i = 0; i < val.length; i++) {
            if (val[i]._id == packageId) {
               setSearches(val[i].benefits)
               setname(val[i].name)
               setperiod(val[i].period)
               setplatforms({label:val[i].platforms})
               setstatus({label:val[i].status,value:val[i].status})
               setprice(val[i].price)
                if(val[i].couponEnabled){
                    setct(val[i].coupon[0].couponTitle)
                    setca(val[i].coupon[0].couponAmountInPercentage)
                    setcouponf(val[i].couponEnabled)
                }
                if(val[i].app_type){
                    val[i].app_type.map((x)=>{rapptype.push({label:x,value:x})})
                }
                setappType(rapptype)
                setisrecurring(val[i].isRecurring ? val[i].isRecurring:false)
            }
         }
    }

    var platform = [
        {
            label:'Android TV'
        },
        {
            label:'Android Phone'
        },
        {
            label:'iPhone'
        },
        {
            label:'PC/MAC'
        },
        {
            label:'Apple TV'
        },
        {
            label:'Fire TV'
        }
    ]
    const handle = (e) =>{
        setprice(e ? e:[]);
    }
    const addsubs=(e)=>{
        e.preventDefault();
        setloading(!loading)
            const params = {
                name: name,
                benefits : searches,
                platforms:platforms.label,
                period:period,
                status:status.value,
                couponEnabled:couponf,
                coupon: !couponf ? []: {couponTitle:ct,couponAmountInPercentage:ca},
                app_type:appType.map(x=>x.label),
                //packageType:packageType.value,
                isRecurring:isrecurring,
                price:price ? price : []
            }
            if(!packageId){
            sampler.put('/addPackages',params)
            .then(res=>{
                setloading(false)
                alertinstance(res)
                if(res.data.error === false){
                    setTimeout(() => {
                        navigate('/subcription')
                    }, 1500);
                }
            })
            }else{
                params["packageId"] = packageId
                sampler.post('/updatePackages',params)
                .then(res=>{
                    setloading(false)
                    alertinstance(res)
                    if(res.data.error === false){
                        setTimeout(() => {
                            navigate('/subcription')
                        }, 1500);
                    }
                })
            }
    }

    const handleapptype = (e) =>{
        setappType(Array.isArray(e)?e:[]);
    }
    const handlepackagetype = (e) =>{
        setpackageType({label:e.label,value:e.value});
    }
    const updateQuery = ({ target }) => {
        // Update query onKeyPress of input box
        setQuery(target.value)
      }
    
      const submitHandler =(e)=> {
        e.preventDefault();
        // Prevent form submission on Enter key    
        if(query !== ""){
            setSearches(searches => [...searches, query])
            setQuery('');
        }
      }
      const deleteRow = (index) => {
        //let name="Mano"
        //setEmps(emps.filter(emp => emp.name !== name))
        let copy_emp=[...searches]
        copy_emp.splice(index,1)
        setSearches(copy_emp)
    }
    const handleStatus=(e)=>{
        setstatus(e)
    }
    let statusOptions=[
        {label:'active',value:'active'},
        {label:'inactive',value:'inactive'}
    ]
    return(
        <>{!loading ? '':<Spin/>}
        <div className='content'>
        <div class="alert alert-primary">  <i class="fa fa-bars" onClick={icon}></i>
            <span className='leftpush'> Add Subscription Packages</span>
        </div>
        <form onSubmit={addsubs}>
                <label><i className="fa fa-user"></i> Add Benefits</label>
                <input
                    value={query}
                    className="form-control"
                    placeholder="Enter benefits*"
                    type="text"
                    onChange={updateQuery}
                />
                <button className="btn btn-success  mt-2" onClick={(e)=>submitHandler(e)}> Add </button>
                <Stack direction="row" spacing={1} className="stack">
                    {searches.map((x,index) =>{
                        return(
                            <>
                            <Chip key={index} label={x} onDelete={()=>deleteRow(index)}/>
                            </>
                        )
                    })}
                </Stack>
                <label><i className="fa fa-heading"></i>Name</label>
                            <input
                                name=""
                                value={name}
                                className="form-control"
                                placeholder="Enter package name*"
                                type="text"
                                onChange={(e)=>setname(e.target.value)}
                            />
                             <label><i className="fa fa-globe"></i> Select App Type</label>
                <Select isMulti className="form-control p-0" value={appType} defaultValue={appType} options={Listapp_type} placeholder="Select App Type*" onChange={handleapptype}></Select>
                            <label><i className="fa fa-heading"></i>Platform</label>
                            <Select className="form-select p-0" options={platform}  value={platforms} defaultValue={platforms} onChange={(e)=>setplatforms(e) } placeholder="Select status*"></Select>
                            <label><i className="fa fa-heading"></i>Period</label>
                            <input
                                name=""
                                value={period}
                                className="form-control"
                                placeholder="Enter period*"
                                type="number"
                                onChange={(e)=>setperiod(e.target.value)}
                            />
                            <label><i className="fa fa-heading"></i>Status</label>
                            <Select className="form-select p-0" options={statusOptions}  value={status} onChange={handleStatus} placeholder="Select platform*"></Select>
                            <input type="checkbox"  checked={couponf} onChange={e => setcouponf(e.target.checked)}/>
                            <label>Enable Coupon</label><br/>
                            {!couponf ? '':
                            <>
                            <label><i className="fa fa-heading"></i>Coupon Title</label>
                            <input
                                className="form-control"
                                placeholder="Enter coupon title*"
                                type="text"
                                value={ct}
                                onChange={(e)=>setct(e.target.value)}
                            />
                            <label><i className="fa fa-heading"></i>Coupon Amount In Percentage</label>
                            <input
                                className="form-control"
                                placeholder="Enter coupon amount*"
                                type="text"
                                value={ca}
                                onChange={(e)=>setca(e.target.value)}
                            /></>}
                             <label className="mt-0">Add Price</label>
                             <Select className="form-control p-0"  options={prices_type} value={price} getOptionLabel={e=>e.country}  placeholder="select" onChange={handle}></Select>
                             

                             <input type="checkbox"  checked={isrecurring} onChange={e => setisrecurring(e.target.checked)}/>
                    <label> Recurring</label><br/>
                {/*<Select className="form-control p-0"  defaultValue={packageType} 
                options={Listpackage_type} placeholder="Select App Type*" onChange={handlepackagetype}></Select>*/}
                            
                            <button type="submit" className='btn btn-primary mt-2'>{labelText}</button>
                            <Link to={'/subcription'}> <button className='btn btn-danger mt-2' style={{'marginLeft': '10px'}}>Back </button></Link>
                           
        </form>
        </div>
        </>
    )
    };

export default Addsubscomponent;
